import { permissions } from "@/helpers/claims";

export default {
  methods: {
    checkPermissions(requredAny) {
      return !requredAny || requredAny.find(x => this.$store.state.permissions.has(x));
    },
    permissionForbidden(name) {
      this.$awn.warning(`${this.lang[this.lg].toast.perm} ${name}!`);
    },
  },
  computed: {
    permissions() {
      return permissions;
    }
  },
};

export function checkPermission(prm, permit) {
  return permit?.length === 4 && (
    (prm[0] === 0 || (prm[0] & permit[0]) !== 0) &&
    (prm[1] === 0 || (prm[1] & permit[1]) !== 0) &&
    (prm[2] === 0 || (prm[2] & permit[2]) !== 0) &&
    (prm[3] === 0 || (prm[3] & permit[3]) !== 0)
  );
};
